import { RichText } from "@/components/richText/richText.component";

import type { Testimonials as TestimonialsType } from "@/sanity.types";

const quoteHasText = (quote: TestimonialsType["quote"] | null | undefined) => {
  if (!Array.isArray(quote)) return false;

  return quote.some((block) => {
    if (!block || typeof block !== "object" || !("children" in block)) {
      return false;
    }

    const children = block.children;
    if (!Array.isArray(children)) return false;

    return children.some(
      (child) =>
        child &&
        typeof child === "object" &&
        "text" in child &&
        typeof child.text === "string" &&
        child.text.trim().length > 0,
    );
  });
};

export const Testimonials = ({ block }: TestimonialsProps) => {
  if (!quoteHasText(block?.quote)) return null;

  const attribution = [block.authorName?.trim(), block.authorLocation?.trim()]
    .filter(Boolean)
    .join(", ");

  return (
    <section
      data-testid="testimonials"
      className="flex w-full flex-col items-center bg-white"
      aria-label="Customer testimonial">
      <blockquote className="mx-auto flex w-full max-w-[1440px] flex-col items-center gap-4 self-stretch px-12 py-10 text-center lg:px-[163px]">
        <div data-testid="testimonials-quote" className="text-center">
          <RichText>{block.quote}</RichText>
        </div>
        {attribution ? (
          <footer
            data-testid="testimonials-attribution"
            className="body-5 text-greyscale-body text-center [font-feature-settings:'liga'_off,'clig'_off]">
            &ndash; {attribution}
          </footer>
        ) : null}
      </blockquote>
    </section>
  );
};

export type TestimonialsProps = {
  block: TestimonialsType;
};
